import { LearningPathRequestApi } from "../DTO/ClientRequest/LearningPath/LearningPathRequest";
import {
  isLearningPathResponseDTO,
  LearningPathResponseApi,
} from "../DTO/ServerResponseType/LearningPath/LearningPath";
import {
  isLearningPathIdResponseDTO,
  LearningPathIdApi,
} from "../DTO/ServerResponseType/LearningPath/LearningPathId";
import {
  isLearningPathIdsResponseDTO,
  LearningPathIdsApi,
} from "../DTO/ServerResponseType/LearningPath/LearningPathIds";
import { ServerClient, serverOrigin } from "./Configs";
import {
  getTypeGuardedArrayVariableAsync,
  getTypeGuardedVariableAsync,
} from "./typeGuard";

class LearningPathServerClient {
  private path = "/learning_path";

  sendToGetAllLearningPathsWithResourcesAndModulesAsync = async (): Promise<
    LearningPathResponseApi[] | never
  > => {
    let url: string =
      serverOrigin + this.path + "/show/all?withLearningPathResources=true";
    try {
      let learningPaths = await getTypeGuardedArrayVariableAsync(
        ServerClient.sendRequestAsync({
          url: url,
          method: "GET",
          credentials: "include",
        }),
        isLearningPathResponseDTO
      );

      return learningPaths;
    } catch (error) {
      console.error("Ошибка:", error);
      throw error;
    }
  };

  sendToUpdateLearningPathAsync = async (
    learningPathId: string,
    learningPathNewData: LearningPathRequestApi
  ): Promise<LearningPathIdsApi | never> => {
    return getTypeGuardedVariableAsync(
      this.sendUpdatedLearningPathAsync(learningPathId, learningPathNewData),
      isLearningPathIdsResponseDTO
    ).then((learningPathIdsDTO: LearningPathIdsApi) => {
      alert("Путь обучения успешно изменен.");
      return learningPathIdsDTO;
    });
  };

  sendUpdatedLearningPathAsync = async (
    learningPathId: string,
    learningPathNewData: LearningPathRequestApi
  ): Promise<unknown> => {
    let url: string = serverOrigin + this.path + "/update/all";

    let response = await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify({
        learningPathId: learningPathId,
        learningPathNewData: learningPathNewData,
      }),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    return response;
  };

  sendToCreateLearningPathAsync = async (
    learningPathData: LearningPathRequestApi
  ): Promise<string | never> => {
    return getTypeGuardedVariableAsync(
      this.sendNewLearningPathAsync(learningPathData),
      isLearningPathIdResponseDTO
    ).then((learningPathIdDTO: LearningPathIdApi) => {
      alert("Путь обучения успешно создан.");
      return learningPathIdDTO.learningPathId;
    });
  };

  sendNewLearningPathAsync = async (
    learningPathData: LearningPathRequestApi
  ): Promise<unknown> => {
    let url: string = serverOrigin + this.path + "/create";

    let response = await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify(learningPathData),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    return response;
  };

  sendToDeleteLearningPathAsync = async (
    learningPathId: string
  ): Promise<unknown> => {
    let url: string = serverOrigin + this.path + "/delete";

    let sendPromise = ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify({ learningPathId: learningPathId }),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    return sendPromise.catch((error) => {
      console.error("Ошибка:", error);
    });
  };
}

let learningPathServerClient = new LearningPathServerClient();

export default learningPathServerClient;
